import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Nav } from './components/site/Nav';
import { Footer } from './components/site/Footer';
import { Home } from './pages/Home';
import { Company } from './pages/Company';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3fai02z30n7dp">
      <div className="w-full bg-bone font-sans text-ink" data-id="element-1" data-mp="3f9yhrh9gegz5">
        <Nav data-id="element-2" data-mp="3f8ez5k0brtu7" />
        <main data-id="element-3" data-mp="3f8n9p58z6n28">
          <Routes data-id="element-4" data-mp="2rknlod31tarc">
            <Route path="/" element={<Home data-id="element-6" data-mp="2rlf7iw6ufu4f" />} data-id="element-5" data-mp="2rk47n7gir6il" />
            <Route path="/company" element={<Company data-id="element-8" data-mp="2mm2j470bqezq" />} data-id="element-7" data-mp="2rit3h6j5vwqy" />
          </Routes>
        </main>
        <Footer data-id="element-9" data-mp="2mnne1xqjvzy4" />
      </div>
    </BrowserRouter>;
}